module.exports = __webpack_public_path__ + "static/media/postcard9.76d5eda9.jpg";